import React, {useEffect} from 'react'

const KinoticketsIFrame = ({deeplinkURL}) => {

    const iframeRef = React.createRef();

    const getFrameHeight = (event) => {
        if(typeof event.data === 'string' && iframeRef.current) {
            const data = JSON.parse(event.data)
            iframeRef.current.height = data.iFrameHeight + 100 + "px"
        }
    }

    useEffect(() => {
        window.addEventListener('message', getFrameHeight, false)     
    }, []);

    useEffect(() => {
        window.addEventListener('message', getFrameHeight, false)
    });       

    return (
        <div id="kinotickets-iframe" className='theme-radius-posters-full'>
            <iframe
                ref={iframeRef}
                name={pmkinoFrontVars.cinemaData.theme.theme_colors + "-theme" + pmkinoFrontVars.cinemaData.theme.accent_color}
                src={deeplinkURL}
                width="100%" 
                height={"600px"} 
                scrolling="no" 
                frameBorder="0"
                sandbox="allow-top-navigation allow-same-origin allow-scripts allow-popups allow-forms"
            />     
        </div>
    )  
}

export default KinoticketsIFrame